import EdmIconButton from "atoms/Buttons/EdmIconButton";
import BackToList from "icons/BackToList.svg";
import { useLocation, useNavigate } from "react-router-dom";

export default function BackToListButton({ resource, params }: { resource: string; params?: string }) {
  const navigate = useNavigate();
  const location = useLocation();

  const goToList = () => {
    const backPath = (location.state as { backPath?: string } | null)?.backPath;
    if (backPath) {
      navigate(backPath);
    } else {
      navigate(`/${resource}${params ? `?${params}` : ""}`);
    }
  };

  return (
    <EdmIconButton size="large" onClick={goToList} data-testid="back-to-list-button" color="primary">
      <BackToList />
    </EdmIconButton>
  );
}
